import React from 'react';
import { Story, Meta } from '@storybook/react';
import ExpertiseBlock from './ExpertiseBlock';

export default {
  title: 'Client/ExpertiseBlock',
  component: ExpertiseBlock,
} as Meta;

const Template: Story = (args) => <ExpertiseBlock settings={args} />;

export const Default = Template.bind({});
Default.args = {
  settings: {
    title: 'Our Expertise',
    description: 'Explore our areas of expertise and discover how we can help you achieve your vision.',
    cta_text: 'View All Services',
    cta_url: '/services',
    blocks: [
      {
        type: 'expertise_item',
        settings: {
          title: 'Residential',
          url: '/residential'
        }
      },
      {
        type: 'expertise_item',
        settings: {
          title: 'Commercial',
          url: '/commercial'
        }
      },
      {
        type: 'expertise_item',
        settings: {
          title: 'Hospitality',
          url: '/hospitality'
        }
      },
      {
        type: 'expertise_item',
        settings: {
          title: 'Urban Design',
          url: '/urban-design'
        }
      },
      {
        type: 'expertise_item',
        settings: {
          title: 'Interior Design',
          url: '/interior'
        }
      },
      {
        type: 'expertise_item',
        settings: {
          title: 'Refurbishment',
          url: '/refurbishment'
        }
      }
    ]
  }
};

export const NoTitle = Template.bind({});
NoTitle.args = {
  settings: {
    ...Default.args.settings,
    title: ''
  }
};

export const NoCTA = Template.bind({});
NoCTA.args = {
  settings: {
    ...Default.args.settings,
    cta_text: '',
    cta_url: ''
  }
};
